export const selectBrands = state => state.brands.list
export const selectBrandsFetched = state => state.brands.fetched
export const selectBrand = (state, id) => state.brands.list[id] || null
